<app-container-transparent>

    <mde-popover
     #appPopover="mdePopover"
     [mdePopoverOverlapTrigger]="true"
     mdePopoverPositionY="above"
     mdePopoverPositionX="before"
     mdePopoverCloseOnClick="false"
    >

        <mat-card >
            <mat-card-title>
                <div fxLayout="row">
                    <div fxFlex="97">
                        <h2 mat-dialog-title>Defina os filtros abaixo</h2>
                    </div>
                    <div fxFlex="3">
                        <mat-icon style="cursor: pointer;" (click)="popoverTrigger.closePopover();">close</mat-icon>
                    </div>
                </div>
            </mat-card-title>
            <mat-card-content>
                <div fxLayout="column" [formGroup]="formGroup">

                    <fieldset>
                        <label>Área</label>
                        <ng-select [items]="area$ | async"
                                   bindLabel="name"
                                   formControlName="area"
                                   bindValue="id"
                                   placeholder="Área"
                                   maxSelectedItems="3"
                                   [multiple]="true"
                                   [(ngModel)]="selectedArea">
                        </ng-select>
                    </fieldset>

                    <fieldset>
                        <label>Função</label>
                        <ng-select [items]="funcao$ | async"
                                   bindLabel="name"
                                   bindValue="id"
                                   formControlName="funcao"
                                   placeholder="Função"
                                   maxSelectedItems="3"
                                   [multiple]="true"
                                   [(ngModel)]="selectedFuncao">
                        </ng-select>
                    </fieldset>

                    <fieldset>
                        <label>Nível</label>
                        <ng-select [items]="nivel$ | async"
                                   bindLabel="name"
                                   bindValue="id"
                                   formControlName="nivel"
                                   placeholder="Nível"
                                   [multiple]="true"
                                   [(ngModel)]="selectedNivel">
                        </ng-select>
                    </fieldset>

                    <fieldset>
                        <label>UF</label>
                        <ng-select [items]="uf$ | async"
                                   bindLabel="name"
                                   bindValue="id"
                                   formControlName="uf"
                                   placeholder="UF"
                                   [multiple]="true"
                                   [(ngModel)]="selectedUf">
                        </ng-select>
                    </fieldset>

                    <fieldset>
                        <label>Status</label>
                        <ng-select [items]="status$ | async"
                                   bindLabel="name"
                                   bindValue="id"
                                   formControlName="status"
                                   placeholder="Status"
                                   [multiple]="true"
                                   [(ngModel)]="selectedStatus">
                        </ng-select>
                    </fieldset>

                </div>
            </mat-card-content>
            <mat-card-actions>
                <button mat-button mat-raised-button color="primary" (click)="aplicarFiltro()" cdkFocusInitial>
                    <mat-icon>push_pin</mat-icon>
                    Aplicar Filtro
                </button>
            </mat-card-actions>
        </mat-card>

    </mde-popover>

    <div flexLayout="row" style="margin-bottom: 20px;">
        <div fxFlex="85"></div>
        <div fxFlex="30" style="padding: 0;">
            <div class="align-button">
                <button (click)="clickNavigation('/favorites/phh')" mat-button mat-raised-button color="primary" class="mfg-button-fav">
                    <mat-icon class="start-outline" style="color: #ed8a19;font-size: 35px;margin-top: -15px;margin-left: -10px">star</mat-icon>
                </button>

                <button
                    mat-button
                    mat-raised-button
                    color="primary"
                    mdePopoverTriggerOn="none"
                    [mdePopoverTriggerFor]="appPopover"
                    mdePopoverTriggerOn="click"
                    #popoverTrigger="mdePopoverTrigger"
                    class="mfg-button"
                >
                    <mat-icon>push_pin</mat-icon>
                    Filtrar
                </button>

                <!--<mat-form-field appearance="outline">
                    <mat-icon matPrefix>search</mat-icon>
                    <input matInput autocomplete="off">
                </mat-form-field>-->
            </div>
        </div>
    </div>

    <div fxLayout="row" *ngIf="loading">
        <mat-progress-bar mode="indeterminate"></mat-progress-bar>
    </div>

    <table mat-table [dataSource]="dataSource" class="mat-table cdk-table mat-elevation-z8">
        <ng-container matColumnDef="favorito">
            <th mat-header-cell  *matHeaderCellDef> <mat-icon style="color: #ed8a19">star</mat-icon> </th>
            <td mat-cell *matCellDef="let element">
                <mat-icon *ngIf="!element.favorito; else elseFav;"
                          (click)="addFavorito(element.codigo, element.pipeId); element.favorito = true;"
                          class="start-outline">star_outline</mat-icon>

                <ng-template #elseFav>
                    <mat-icon (click)="removeFavorito(element.codigo); element.favorito = false;"
                              class="start-outline" style="color: #ed8a19;">star_rate</mat-icon>
                </ng-template>
            </td>
        </ng-container>

        <ng-container matColumnDef="foto">
            <th mat-header-cell  *matHeaderCellDef> Foto </th>
            <td mat-cell *matCellDef="let element"> <!--{{element.foto}}--> - </td>
        </ng-container>

        <ng-container matColumnDef="candidato">
            <th mat-header-cell  *matHeaderCellDef> Candidato</th>
            <td mat-cell *matCellDef="let element"> {{element.candidato }} </td>
        </ng-container>

        <ng-container matColumnDef="mercado">
            <th mat-header-cell  *matHeaderCellDef> Área </th>
            <td mat-cell *matCellDef="let element"> {{element.mercado }} </td>
        </ng-container>

        <ng-container matColumnDef="cargo">
            <th mat-header-cell  *matHeaderCellDef> Função </th>
            <td mat-cell *matCellDef="let element">{{ (!!element.cargo) ? element.cargo : ' - ' }}</td>
        </ng-container>

        <ng-container matColumnDef="senioridade">
            <th mat-header-cell  *matHeaderCellDef> Nível </th>
            <td mat-cell *matCellDef="let element">{{ (!!element.senioridade) ? element.senioridade : ' - ' }}</td>
        </ng-container>

        <ng-container matColumnDef="disponibilidadeGeografica">
            <th mat-header-cell  *matHeaderCellDef> Disponibilidade </th>
            <td mat-cell *matCellDef="let element">
                {{ (!!element.disponibilidadeGeografica) ? element.disponibilidadeGeografica : ' - ' }}
            </td>
        </ng-container>

        <ng-container matColumnDef="status">
            <th mat-header-cell *matHeaderCellDef> Status </th>
            <td mat-cell *matCellDef="let element">{{ (!!element.status) ? element.status : ' - ' }}</td>
        </ng-container>

        <ng-container matColumnDef="contatos" stickyEnd>
            <th mat-header-cell *matHeaderCellDef>Contatos</th>
            <td mat-cell *matCellDef="let element">
                <div fxLayout="row">
                    <div *ngFor="let info of element.contatos" style="margin-left: 2px;">
                        <img width="25" height="25" title="{{ info }}}" *ngIf="info == 'LINKEDIN'" src="assets/linkedin-in.png" />
                        <img width="25" height="25" title="{{ info }}}" *ngIf="info == 'WHATSAPP'" src="assets/whatsapp-icon-in.png" />
                        <img width="25" height="25" title="{{ info }}}" *ngIf="info == 'EMAIL'" src="assets/email-icon-in.png" />
                        <img width="25" height="25" title="{{ info }}}" *ngIf="info == 'CURRÍCULO'" src="assets/curriculo-icon-in.png" />
                    </div>
                </div>
            </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

        <tr class="mat-row" *matNoDataRow>
            <td class="mat-cell" colspan="9">Nenhum registro encontrado</td>
        </tr>
    </table>
    <div fxLayout="row" *ngIf="loading" style="margin-top: 0;">
        <mat-progress-bar mode="indeterminate"></mat-progress-bar>
    </div>

    <app-pipe-pagination *ngIf="isPipefyPageEvent && dataSource.data.length"
                         [loading]="loading"
                         [pageSize]="pageSize"
                         [pageRanger]="pageRanger"
                         [startCursor]="dataSource.data[0].pageInfo.startCursor"
                         [endCursor]="dataSource.data[0].pageInfo.endCursor"
                         [hasNextPage]="dataSource.data[0].pageInfo.hasNextPage"
                         [hasPreviousPage]="dataSource.data[0].pageInfo.hasPreviousPage"
                         (pageEvent)="pageEvent($event)"></app-pipe-pagination>

    <mat-paginator *ngIf="!isPipefyPageEvent"
            [disabled]="loading"
            [pageSizeOptions]="pageRanger"
            [length]="length"
            [pageSize]="pageSize"
            (page)="changePage($event)"></mat-paginator>
</app-container-transparent>
